import './wiz-drop-down-menu.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';

export class WizDropDownMenu extends Component {

  static propTypes = {
    value: PropTypes.any,
  onChange: PropTypes.func,
  values: PropTypes.any,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  showDefaultValue: PropTypes.bool,
  usePlainText: PropTypes.bool
  };

  render() {
    const { value,
            onChange,
            values,
            disabled,
            placeholder,
            className,
            showDefaultValue = false
    } = this.props;

    const dropDownMenuProps = {
      value,
      onChange,
      disabled,
      className
    };

    const nullMenuItemProps = {
      value: null,
      primaryText: placeholder
    };

    if (showDefaultValue) {
      return (
        <DropDownMenu { ...dropDownMenuProps }>
          { _.map(values, (item) => {
            return <MenuItem key={ item._id } value={ item._id } primaryText={ item.name }/>;
          }) }
        </DropDownMenu>
      );
    }

    return (
      <DropDownMenu { ...dropDownMenuProps }>
        <MenuItem { ...nullMenuItemProps }/>
        {
          _.map(values, (item, i) => {
            const menuItemsProps = {
              key: item._id,
              value: item._id,
              primaryText: item.name
            };

            return <MenuItem { ...menuItemsProps }/>;
          })
        }
      </DropDownMenu>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/wiz-drop-down-menu/wiz-drop-down-menu.js